export const adjustElementPosition = (selector: string) => {
  const element = document.querySelector(selector) as HTMLElement | null;
  if (!element) return () => {};
  let lastTop = element.getBoundingClientRect().top;
  let ticking = false;

  const update = () => {
    ticking = false;
    const rect = element.getBoundingClientRect();
    const top = rect.top;
    if (Math.abs(top - lastTop) > 10) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      lastTop = top;
    }
  };

  const onResize = () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  };

  const observer = new ResizeObserver(onResize);
  observer.observe(element);

  return () => observer.disconnect();
};
